
<div class="container">
  <div class="row">
    <div class="col page-title-container">
      <h2 class="hidden-xs-down">Projects</h2>
      <ol class="breadcrumb">
        <li class="breadcrumb-item active">Projects</li>
      </ol>
      <error [error]="error"></error>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <list-controls [search]="searchText" [searchHelp]="searchHelp" [limit]="pageSize" [page]="currentPage" [numPages]="maxPages" [totalCount]="totalCount" (onChange)="onListControlsChange($event)"><a class="btn btn-primary" href="javascript:void(0)" (click)="create()">Create Project</a></list-controls>
    </div>
  </div>
  <div class="row">
    <div class="col pb-2">
      <div class="form-check">
        <input class="form-check-input" type="checkbox" autoLinkToLabel [(ngModel)]="closedProjects" (change)="refreshBrowser()">
        <label class="form-check-label">Show Closed Projects</label>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <div class="row" *ngFor="let project of projects">
        <div class="col">
          <div class="card-item">
            <div class="card-progress-bar float-right">
              <div class="progress">
                <div class="progress-bar" role="progressbar" title="{{ project.deployedToK2PercentageBar?.title }}" [ngClass]="project.deployedToK2PercentageBar?.type" [style.width]="project.deployedToK2PercentageBar?.width + '%'">{{project.deployedToK2PercentageBar?.value + "%"}}</div>
              </div>
            </div>
            <h4>{{ project.name }}<span class="badge ml-1" *ngIf="!project.geo_region_id" [ngClass]="{'badge-danger': true}">Needs Geo Region</span><span class="badge ml-1" *ngIf="project.rejected" [ngClass]="{'badge-warning': true}">Rejected</span></h4><span class="badge ml-1" *ngIf="!project.geo_region_id &amp;&amp; project.allowSetGeoRegion" [ngClass]="{'badge-danger': true}">
              <select-geo-region name="geoRegion" [(ngModel)]="project.geoRegionId" (change)="geoRegionChanged(project)"></select-geo-region></span>
            <property-container>
              <property-item><a [routerLink]="['/project']" [queryParams]="{id: project.id}">Details</a></property-item>
              <property-item [showIf]="project.geo_region_id"><a [routerLink]="['/workflow', project.workflowId]">Set Up Project &amp; Add Devices</a></property-item>
              <property-item><a [routerLink]="['/dashboard']" [queryParams]="{projectId: project.id}">Dashboard</a></property-item>
              <property-item><a [href]="'/#/budget-expenses?projectId=' + project.id">Budget & Expenses</a></property-item>
            </property-container>
            <property-container>
              <property-item [showIf]="project.geo_region_id"><a [routerLink]="['/sites']" [queryParams]="{projectId: project.id}">{{ project.siteCount || 0 }} site(s)</a></property-item>
              <property-item [showIf]="project.geo_region_id"><a [routerLink]="['/orders']" [queryParams]="{projectId: project.id}">{{ project.orderCount || 0 }} order(s)</a></property-item>
              <property-item [showIf]="project.enableBulkOrdering &amp;&amp; project.geo_region_id"><a [href]="'/#/bulk-orderings?projectId=' + project.id">{{ project.bulkOrderCount || 0 }} bulk order(s)</a></property-item>
              <property-item [showIf]="project.geo_region_id"><a [routerLink]="['/deployments']" [queryParams]="{projectId: project.id}">{{ project.deploymentCount || 0 }} deployments(s)</a></property-item>
              <property-item><a [routerLink]="['/software-solutions']" [queryParams]="{projectId: project.id}">software solution(s)</a></property-item>
            </property-container>
            <property-container>
              <property-item [showIf]="project.countryName">{{ project.countryName }}</property-item>
              <property-item [showIf]="project.csa">CSSA: {{ project.csa }}</property-item>
              <property-item [showIf]="project.ampId">AMP: {{ project.ampId }}</property-item>
              <property-item [showIf]="project.msId &amp;&amp; project.geoRegionId === 'EMEA'">MS ID: {{ project.msId }}</property-item>
            </property-container>
            <property-container>
              <property-item [showIf]="project.startDate">Start Date: {{ project.startDate | date: 'yyyy-MM-dd' : 'UTC'}}</property-item>
            </property-container>
            <property-container>
              <property-item [showIf]="project.estimatedCompletionDate">Estimated Completion Date: {{ project.estimatedCompletionDate | date: 'yyyy-MM-dd' : 'UTC'}}</property-item>
            </property-container>
            <property-container>
              <property-item>{{ project.deployedDevices | number:0 }} device(s) deployed</property-item>
              <property-item>{{ project.plannedDevices | number:0 }} device(s) planned</property-item>
              <property-item>{{ project.totalDevices | number:0 }} total devices</property-item>
            </property-container>
            <property-container>
              <property-item [showIf]="project.transitionLeads?.length"><span>Transition Leads: </span>
                <ng-template ngFor let-person [ngForOf]="project.transitionLeads" let-isFirst="first">
                  <ng-template [ngIf]="!isFirst">, </ng-template><a [href]="'mailto:' + person.emailAddress">{{ person.firstName }} {{ person.lastName }}</a>
                </ng-template>
              </property-item>
            </property-container>
            <property-container class="red">
              <property-item [showIf]="project.overBudget"><span class="oi oi-dollar"></span> {{ project.overBudgetMessage }}</property-item>
            </property-container>
            <property-container class="red">
              <property-item [showIf]="project.pastSchedule"><span class="oi oi-clock"></span> {{ project.pastScheduleMessage }}</property-item>
            </property-container>
            <div class="clearfix"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>